import React from 'react';
import { Link, Space } from '@kl/components-v6';
import { KSCIcon } from 'shared/ui/icons';
import { Locale } from '../locale';
import { StyledKSCLogo, StyledLogoText, StyledText } from './styled';

export const KscLogo = () => (
    <StyledKSCLogo>
        <Link href="/">
            <Space direction="horizontal" size="10">
                <KSCIcon size={49} />
                <StyledLogoText>
                    <StyledText lineHeight="1.1" type="BTM3">
                        <Locale localizationKey="Landing.Kaspersky_Caption" />
                    </StyledText>
                    <StyledText type="BTM3">
                        <Locale localizationKey="Landing.SecurityCenter_Caption" />
                    </StyledText>
                    <StyledText type="BTM4">
                        <Locale localizationKey="Landing.CloudConsole_Caption" />
                    </StyledText>
                </StyledLogoText>
            </Space>
        </Link>
    </StyledKSCLogo>
);
